import { render, staticRenderFns } from "./LogicCheck.vue?vue&type=template&id=48901301&scoped=true"
import script from "./LogicCheck.vue?vue&type=script&lang=ts"
export * from "./LogicCheck.vue?vue&type=script&lang=ts"
import style0 from "./LogicCheck.vue?vue&type=style&index=0&id=48901301&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48901301",
  null
  
)

export default component.exports